module.exports = __webpack_public_path__ + "img/Y_Line.586fa77a.png";